/* ===================================================
   ALEXIS AI PAGES — brandfluff.com.au
   FAQ accordion + buy button tracking
   =================================================== */

(function () {
  'use strict';


  /* ── FAQ ACCORDION ────────────────────────────────────
     Toggles .is-open on .ai-faq__item.
     CSS handles the max-height animation and icon rotation.
     Only one item open at a time.
  ─────────────────────────────────────────────────────── */

  function initFAQ() {
    var items = document.querySelectorAll('.ai-faq__item');
    if (!items.length) return;

    items.forEach(function (item, index) {
      var trigger = item.querySelector('.ai-faq__trigger');
      var body    = item.querySelector('.ai-faq__body');
      if (!trigger || !body) return;

      // Wire up accessibility attributes
      var bodyId = 'faq-body-' + index;
      body.id    = bodyId;
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', bodyId);

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        // Close every item
        items.forEach(function (other) {
          other.classList.remove('is-open');
          var otherTrigger = other.querySelector('.ai-faq__trigger');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        });

        // If this item was closed, open it
        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }


  /* ── BUY BUTTON TRACKING ──────────────────────────────
     Fires Meta Pixel InitiateCheckout + GA4 begin_checkout
     when a tagged buy button is clicked.

     CMO Brain buttons:       class="... cmo-buy-btn"
     Realism Director buttons: class="... realism-buy-btn"

     Both fbq() and gtag() are guarded — if tracking IDs
     haven't been replaced yet, calls are silently skipped.
  ─────────────────────────────────────────────────────── */

  function firePixel(eventName, params) {
    if (typeof fbq === 'function') {
      fbq('track', eventName, params);
    }
  }

  function fireGA4(eventName, params) {
    if (typeof gtag === 'function') {
      gtag('event', eventName, params);
    }
  }

  function initBuyButtonTracking() {

    // CMO Brain — $297
    document.querySelectorAll('.cmo-buy-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        firePixel('InitiateCheckout', {
          content_name: 'Alexis AI CMO Brain',
          value:        297.00,
          currency:     'USD'
        });
        fireGA4('begin_checkout', {
          currency: 'USD',
          value:    297.00,
          items: [{
            item_name: 'Alexis AI CMO Brain',
            price:     297.00,
            quantity:  1
          }]
        });
      });
    });

    // Realism Director — $97
    document.querySelectorAll('.realism-buy-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        firePixel('InitiateCheckout', {
          content_name: 'Alexis AI Ultra Realism Director',
          value:        97.00,
          currency:     'USD'
        });
        fireGA4('begin_checkout', {
          currency: 'USD',
          value:    97.00,
          items: [{
            item_name: 'Alexis AI Ultra Realism Director',
            price:     97.00,
            quantity:  1
          }]
        });
      });
    });
  }


  /* ── CAPTURE FORM STUB ────────────────────────────────
     Prevents the placeholder form from submitting to "#".
     Remove this block once Klaviyo embed is in place —
     Klaviyo's own JS handles submission.
  ─────────────────────────────────────────────────────── */

  function initCaptureFormStub() {
    var form = document.querySelector('.ai-capture-form');
    if (!form) return;

    // Only intercept if Klaviyo hasn't replaced the form
    if (form.getAttribute('action') === '#') {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.ai-capture-form__btn');
        if (btn) {
          btn.textContent = 'Thanks — we\'ll be in touch!';
          btn.disabled = true;
        }
      });
    }
  }


  /* ── INIT ─────────────────────────────────────────────
     Safe whether script loads before or after DOM ready.
  ─────────────────────────────────────────────────────── */

  function init() {
    initFAQ();
    initBuyButtonTracking();
    initCaptureFormStub();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());